module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_04.874d5e9f.jpg";